import { ConsentTypeDto, UserConsentDto } from '../dto/consent-type.dto';

export class ConsentTypeEntity {
  constructor(private dto: ConsentTypeDto) {}
  get id(): number { return this.dto.id; }
  get code(): string { return this.dto.code; }
  get name(): string { return this.dto.name; }
  get description(): string | undefined { return this.dto.description; }
  get isRequired(): boolean { return this.dto.isRequired; }
  get order(): number { return this.dto.order; }
  get isActive(): boolean { return this.dto.isActive; }
  get category(): string { return this.dto.category; }
}

export class UserConsentEntity {
  constructor(private dto: UserConsentDto) {}
  get type(): ConsentTypeEntity { return new ConsentTypeEntity(this.dto.consentType as any); }
  get isAccepted(): boolean { return this.dto.isAccepted; }
  get version(): number { return this.dto.version; }
  get acceptedAt(): string | undefined { return this.dto.acceptedAt; }
  get withdrawnAt(): string | undefined { return this.dto.withdrawnAt; }
}
